module.exports = __webpack_public_path__ + "img/hamburger.a450cc10.svg";